exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".photoUploader__addPhoto___1oba9 {\n  font-size: 48px;\n  color: #dbdbdb; }\n\n.photoUploader__modal___212iE {\n  top: 20px; }\n\n.photoUploader__content___1EmSs {\n  text-align: center;\n  padding-top: 20px; }\n\n.photoUploader__photoEditor___1h8_o {\n  max-width: 100%;\n  max-height: calc(100vh - 285px);\n  min-height: calc(100vh - 285px); }\n  @media screen and (max-width: 576px) {\n    .photoUploader__photoEditor___1h8_o {\n      max-height: calc(100vh - 340px);\n      min-height: calc(100vh - 340px); } }\n\n.photoUploader__controls___3quqe {\n  margin-top: 10px;\n  margin-bottom: -10px; }\n  .photoUploader__controls___3quqe > i {\n    font-size: 20px;\n    margin: 10px;\n    cursor: pointer;\n    color: #f94144; }\n    .photoUploader__controls___3quqe > i.photoUploader__rotateLeft___G88DM {\n      -webkit-transform: scaleX(-1);\n      transform: scaleX(-1); }\n    .photoUploader__controls___3quqe > i.photoUploader__flipVertical___1ioKa {\n      -webkit-transform: rotate(90deg);\n      transform: rotate(90deg); }\n", ""]);

// exports
exports.locals = {
	"addPhoto": "photoUploader__addPhoto___1oba9",
	"modal": "photoUploader__modal___212iE",
	"content": "photoUploader__content___1EmSs",
	"photoEditor": "photoUploader__photoEditor___1h8_o",
	"controls": "photoUploader__controls___3quqe",
	"rotateLeft": "photoUploader__rotateLeft___G88DM",
	"flipVertical": "photoUploader__flipVertical___1ioKa"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/PhotoUploader/photoUploader.scss
// module id = 2194
// module chunks = 6